export default __webpack_public_path__ + "static/media/statement-page1400.7148463f.jpg";